import React from 'react'
import { useLocation } from 'react-router-dom';
import Navigation  from '../Navigation'


function ClassDetail() {

  const { state } = useLocation();
  const { classId, className } = state;
  return (
    <Navigation heading={className} >
    <div>{classId}</div>

    </Navigation>
  )
}

export default ClassDetail